import {
  Component,
  Output,
  EventEmitter,
  inject,
  ChangeDetectionStrategy,
  OnInit,
  OnDestroy,
} from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FileDropZoneComponent } from '../components/file-drop-zone/file-drop-zone.component';
import { UploadedFilesGridComponent } from '../components/uploaded-files-grid/uploaded-files-grid.component';
import { FileUploadService } from '../../../../core/services/file-upload.service';

@Component({
  selector: 'app-step-upload-files',
  standalone: true,
  imports: [FileDropZoneComponent, UploadedFilesGridComponent],
  templateUrl: './step-upload-files.component.html',
  styleUrls: ['./step-upload-files.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepUploadFilesComponent implements OnInit, OnDestroy {
  private readonly fileUploadService = inject(FileUploadService);
  private readonly destroy$ = new Subject<void>();

  @Output() filesChanged = new EventEmitter<boolean>();

  hasUploadedFiles = false;
  isUploading = false;

  ngOnInit(): void {
    this.fileUploadService.uploadState$
      .pipe(takeUntil(this.destroy$))
      .subscribe(state => {
        const hadFiles = this.hasUploadedFiles;
        this.hasUploadedFiles = state.parsedFiles.length > 0;
        this.isUploading = state.isUploading;

        if (hadFiles !== this.hasUploadedFiles) {
          this.filesChanged.emit(this.hasUploadedFiles);
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onFilesUploaded(): void {}
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onFileRemoved(): void {}

  canProceed(): boolean {
    return this.fileUploadService.canProceedFromUploadStep;
  }

  shouldWarnOnLeave(): boolean {
    return this.isUploading;
  }

  getLeaveWarningMessage(): string {
    return 'You have uploads in progress. Are you sure you want to leave? Your uploads will be cancelled.';
  }
}
